import Vue from 'vue'
import moment from 'moment'
import { Button, Table, Modal, Select, Radio, Input, Tabs, Form, DatePicker, message, Upload, Icon } from 'ant-design-vue'
import passengerSegList from '@/components/passenger-seg-list-new'
// import VerificationCode from '@/components/verification-code'
import MobileVerification from '@/components/mobileverification'
import ImgCaptcha from '@/components/imgcaptcha'

import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Table)
Vue.use(Select)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Modal)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Icon)
Vue.use(passengerSegList)
// Vue.use(VerificationCode)
Vue.use(MobileVerification)
Vue.use(ImgCaptcha)

Vue.use(SliderCaptcha)
Vue.use(VerificationCode)

Vue.prototype.$message = message
Vue.prototype.$modal = Modal
Vue.prototype.$error = Modal.error
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.prototype.moment = moment
